var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto mb-10"},[_c('v-img',{attrs:{"src":_vm.menuImgUrl,"height":"200px"}}),_c('v-card-title',[_vm._v(_vm._s(_vm.menuTitle))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }